import { render, staticRenderFns } from "./NotesPage.vue?vue&type=template&id=f00f8758&scoped=true"
import script from "./NotesPage.vue?vue&type=script&lang=js"
export * from "./NotesPage.vue?vue&type=script&lang=js"
import style0 from "./NotesPage.vue?vue&type=style&index=0&id=f00f8758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00f8758",
  null
  
)

export default component.exports